import { User, UserStatus } from "@/schemas/User"

export function resolveUserStatus(user: User | null): UserStatus {
  if (!user) return "NOT_LOGGED_IN"
  if (user.license.isExpired) return "EXPIRED"
  if (user.license.isRevoked) return "REVOKED"
  if (user.account.termsConditionsEthicsAcknowledgedAt === null) return "ONBOARDING"
  return "ACTIVE"
}
